import { render, staticRenderFns } from "./batch-set-messages-modal.vue?vue&type=template&id=821796fc"
import script from "./batch-set-messages-modal.vue?vue&type=script&lang=js"
export * from "./batch-set-messages-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports